import React, { useState, useEffect } from "react";
import workflowPreviewImg from "../../Images/Templates/workflowpreview.jpeg";
import { Hierarchy } from "iconsax-react";
import { Box, Paper, TextField, Button, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery, FormControl, Select, MenuItem, InputAdornment, Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MessageIcon from "@mui/icons-material/Message";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DraftsIcon from "@mui/icons-material/Drafts";
import ReplyIcon from "@mui/icons-material/Reply";
import ScheduleIcon from "@mui/icons-material/Schedule";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageIcon from "@mui/icons-material/Language";
import WorkflowTable from "../../components/Workflow/WorkflowTable";
import WorkflowSectionHeader from "../../components/Workflow/WorkflowSectionHeader";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { useDispatch, useSelector } from "react-redux";
import { fetchWorkflows, createWorkflow, setSelectedWorkflow, fetchWorkflowById, fetchTriggers, addNodeToBranch } from "../../redux/Slice/Workflow/workflowSlice";
import { fetchUserPermissions } from "../../redux/Slice/User/userDetailsSlice";
import AuthView from "../../utils/AuthView";
import { getAuthToken } from "../../utils/getAuthToken";
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { isSubscriptionBlockedError, checkSubscriptionActive } from '../../utils/subscriptionError';

const NO_QR_NUMBERS = []; // stable empty list for the selector below

const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN || 'http://localhost:8000';

// Instagram and Facebook triggers are not stored in the DB Trigger collection — they are
// defined locally in their drawer components. This map provides the same config so the
// template flow can build the trigger node without a DB hit.
const LOCAL_CHANNEL_TRIGGERS = {
  'First incoming DM': {
    name: 'First incoming DM',
    triggerType: 'root',
    category: 'Message',
    config: [
      {
        name: 'Conditions',
        fields: [
          { label: 'Trigger when', type: 'select', options: ['Any first DM', 'When message contains keywords'], selectedValue: 'Any first DM' },
          { label: 'Keywords (comma-separated)', type: 'text', selectedValue: '' },
        ],
      },
      {
        name: 'Select Time Interval',
        fields: [
          { label: 'Select Interval Duration', type: 'number', selectedValue: 1 },
          { label: 'Select Duration Type', type: 'select', options: ['Minutes', 'Hours', 'Days'], selectedValue: 'Days' },
          { label: 'Timezone', type: 'select', options: ['timezones'], selectedValue: 'Asia/Karachi' },
        ],
      },
    ],
  },
  'First incoming Facebook message': {
    name: 'First incoming Facebook message',
    triggerType: 'root',
    category: 'Message',
    config: [
      {
        name: 'Conditions',
        fields: [
          { label: 'Trigger when', type: 'select', options: ['Any first message', 'When message contains keywords'], selectedValue: 'Any first message' },
          { label: 'Keywords (comma-separated)', type: 'text', selectedValue: '' },
        ],
      },
      {
        name: 'Select Time Interval',
        fields: [
          { label: 'Select Interval Duration', type: 'number', selectedValue: 1 },
          { label: 'Select Duration Type', type: 'select', options: ['Minutes', 'Hours', 'Days'], selectedValue: 'Days' },
          { label: 'Timezone', type: 'select', options: ['timezones'], selectedValue: 'Asia/Karachi' },
        ],
      },
    ],
  },
  // Same config as ChooseWebsiteTriggerDrawer.jsx's WEBSITE_TRIGGERS entry
  'First incoming website chat message': {
    name: 'First incoming website chat message',
    triggerType: 'root',
    category: 'Message',
    config: [
      {
        name: 'Conditions',
        fields: [
          { label: 'Trigger when', type: 'select', options: ['Any first message', 'When message contains keywords'], selectedValue: 'Any first message' },
          { label: 'Keywords (comma-separated)', type: 'text', selectedValue: '' },
        ],
      },
      {
        name: 'Select Time Interval',
        fields: [
          { label: 'Select Interval Duration', type: 'number', selectedValue: 1 },
          { label: 'Select Duration Type', type: 'select', options: ['Minutes', 'Hours', 'Days'], selectedValue: 'Days' },
          { label: 'Timezone', type: 'select', options: ['timezones'], selectedValue: 'Asia/Karachi' },
        ],
      },
    ],
  },
  'Comment on story (or reply to story)': {
    name: 'Comment on story (or reply to story)',
    triggerType: 'root',
    category: 'Message',
    config: [
      {
        name: 'Conditions',
        fields: [
          { label: 'Trigger when', type: 'select', options: ['Any reply', 'When reply contains keywords'], selectedValue: 'Any reply' },
          { label: 'Keywords (comma-separated)', type: 'text', selectedValue: '' },
        ],
      },
      {
        name: 'Select Time Interval',
        fields: [
          { label: 'Select Interval Duration', type: 'number', selectedValue: 1 },
          { label: 'Select Duration Type', type: 'select', options: ['Minutes', 'Hours', 'Days'], selectedValue: 'Days' },
          { label: 'Timezone', type: 'select', options: ['timezones'], selectedValue: 'Asia/Karachi' },
        ],
      },
    ],
  },
  'Comment on post': {
    name: 'Comment on post',
    triggerType: 'root',
    category: 'Message',
    config: [
      {
        name: 'Post',
        fields: [
          { label: 'Media ID', type: 'select', options: [], selectedValue: '' },
        ],
      },
      {
        name: 'Conditions',
        fields: [
          { label: 'Trigger when', type: 'select', options: ['Any comment', 'When comment contains keywords'], selectedValue: 'Any comment' },
          { label: 'Keywords (comma-separated)', type: 'text', selectedValue: '' },
        ],
      },
      {
        name: 'Select Time Interval',
        fields: [
          { label: 'Select Interval Duration', type: 'number', selectedValue: 1 },
          { label: 'Select Duration Type', type: 'select', options: ['Minutes', 'Hours', 'Days'], selectedValue: 'Days' },
          { label: 'Timezone', type: 'select', options: ['timezones'], selectedValue: 'Asia/Karachi' },
        ],
      },
    ],
  },
  'Automatic Reply to Comment': {
    name: 'Automatic Reply to Comment',
    triggerType: 'root',
    category: 'Message',
    config: [
      {
        name: 'Post',
        fields: [
          { label: 'Media ID', type: 'select', options: [], selectedValue: '' },
        ],
      },
      {
        name: 'Conditions',
        fields: [
          { label: 'Trigger when', type: 'select', options: ['Any comment', 'When comment contains keywords'], selectedValue: 'Any comment' },
          { label: 'Keywords (comma-separated)', type: 'text', selectedValue: '' },
        ],
      },
      {
        name: 'Reply',
        fields: [
          { label: 'Reply message', type: 'textarea', selectedValue: '' },
        ],
      },
    ],
  },
};

const WORKFLOW_TEMPLATES = [
  {
    id: 'first-message',
    label: 'First Incoming Message',
    description: 'Triggers when a contact sends their first message on any channel.',
    multiChannel: true,
    previewTitle: 'When contact messages for the first time',
    previewDescriptions: [
      'Make a great first impression, automatically. This automation ensures new contacts get an instant, friendly welcome.',
      'When someone messages you for the first time, the automation sends a personalized greeting, shares key info, or guides them to take the next step: like browsing products, booking a service, or joining a list.',
      'Perfect for businesses that want to start every conversation on the right note and turn new contacts into long-term customers.',
    ],
    channelConfig: {
      whatsapp: { triggerName: 'Contact sends first incoming message', workflowName: 'First Message' },
      // WhatsApp linked by QR: the same trigger, but the workflow belongs to ONE QR number (offered only to QR-enabled accounts).
      qr: { triggerName: 'Contact sends first incoming message', workflowName: 'First Message' },
      instagram: { triggerName: 'First incoming DM', workflowName: 'First Incoming DM' },
      facebook: { triggerName: 'First incoming Facebook message', workflowName: 'First Facebook Message' },
      website: { triggerName: 'First incoming website chat message', workflowName: 'First Website Message' },
    },
  },
  {
    id: 'comment-on-story',
    label: 'Comment on story (or reply to story)',
    workflowName: 'Comment on Story',
    triggerName: 'Comment on story (or reply to story)',
    description: 'Triggers when someone comments on or replies to your Instagram story. Defaults to any reply.',
    forceChannel: 'instagram',
  },
  {
    id: 'comment-on-post',
    label: 'Comment on post',
    description: 'Triggers when someone comments on any of your posts. Defaults to any post and any comment.',
    multiChannel: true,
    previewMockup: 'comment',
    previewTitle: 'When someone comments on your post',
    previewDescriptions: [
      'Automatically reach out when anyone comments on your posts — no manual follow-up needed.',
      'When a comment comes in, the automation sends a private message to the commenter — great for promotions, lead capture, or customer support.',
      'By default this workflow runs on any post and any comment. You can narrow it down to specific posts or keywords in the trigger settings.',
    ],
    channelConfig: {
      instagram: { triggerName: 'Comment on post', workflowName: 'Comment on Post' },
      facebook: { triggerName: 'Comment on post', workflowName: 'Comment on Post (Facebook)' },
    },
  },
  {
    id: 'automatic-reply-to-comment',
    label: 'Automatic Reply to Comment',
    description: 'Automatically replies to comments on your posts. Defaults to any post and any comment.',
    multiChannel: true,
    previewMockup: 'comment',
    previewTitle: 'Automatically reply to post comments',
    previewDescriptions: [
      'Reply to comments on your posts instantly — no manual effort required.',
      'When someone comments, the automation publicly replies to the comment with your message. Use it to say thank you, share a promo code, or guide users to DM you.',
      'By default this workflow runs on any post and any comment. Configure specific posts or keyword conditions in the trigger settings.',
    ],
    channelConfig: {
      instagram: { triggerName: 'Automatic Reply to Comment', workflowName: 'Auto Reply to Comment' },
      facebook: { triggerName: 'Automatic Reply to Comment', workflowName: 'Auto Reply to Comment (Facebook)' },
    },
  },
  {
    id: 'place-order',
    label: 'Contact places an order',
    workflowName: 'Placed Order',
    triggerName: 'Contact places an order',
    description: 'Triggers when a contact places an order. Sets timezone and a 1-day interval.',
  },
  {
    id: 'office-time',
    label: 'Office time flow',
    workflowName: 'Office Flow',
    triggerName: 'Office-Time Flow',
    description: 'Routes contacts based on office hours. Defaults to Mon–Fri, 9am–6pm (UTC).',
  },
];

// Templates that can run on a WhatsApp (QR) number. In the QR tab every other template is still listed but disabled, with the
// reason below -- they need Instagram / Facebook, or the official WhatsApp number's order events.
const QR_TEMPLATE_IDS = new Set(['first-message', 'office-time']);
const QR_TEMPLATE_UNAVAILABLE_REASON = {
  'comment-on-story': 'Instagram only',
  'comment-on-post': 'Instagram / Facebook only',
  'automatic-reply-to-comment': 'Instagram / Facebook only',
  'place-order': 'Needs the official WhatsApp (Meta) number',
};

function workflowCreateChannelSuffix(ch) {
  if (ch === "qr") return "?channel=qr";
  if (ch === "instagram") return "?channel=instagram";
  if (ch === "facebook") return "?channel=facebook";
  if (ch === "website") return "?channel=website";
  if (ch === "whatsapp_web") return "?channel=whatsapp_web";
  return "";
}

function getRelativeTime(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const diff = now - date;
  const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
  if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  const minutes = Math.floor(diff / (1000 * 60));
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  return "just now";
}

const WORKFLOW_LIST_CHANNEL_ICON_COLORS = {
  whatsapp: "#1e7d4d",
  instagram: "#E1306C",
  facebook: "#1877F2",
  website: "#0b5fff",
  whatsapp_web: "#1e7d4d",
};

function workflowListChannelIconColor(channel) {
  return WORKFLOW_LIST_CHANNEL_ICON_COLORS[channel] || WORKFLOW_LIST_CHANNEL_ICON_COLORS.whatsapp;
}

function getWorkflowListTriggerIcon(trigger, channel) {
  const color = workflowListChannelIconColor(channel);
  const sx = { color };
  switch (trigger) {
    case "Contact sends first incoming message":
    case "First incoming DM":
    case "First incoming Facebook message":
    case "First incoming Messenger message":
    case "Contact places an order":
      return <PersonIcon sx={sx} />;
    case "Teammate closes a conversation":
    case "When contact is closed":
      return <CheckCircleIcon sx={sx} />;
    case "draft":
    case "Comment on story (or reply to story)":
    case "Comment on post":
      return <DraftsIcon sx={sx} />;
    case "Automatic Reply to Comment":
      return <ReplyIcon sx={sx} />;
    case "Office-Time Flow":
      return <ScheduleIcon sx={sx} />;
    default:
      return <PersonIcon sx={sx} />;
  }
}


const Workflow = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const dispatch = useDispatch();
  const { workflows: workflowGroups, loading, error, triggers: reduxTriggers } = useSelector(state => state.workflow);
  const WorkflowPermissions = useSelector(
    (state) => state.userDetails.userPermissions?.permissions?.Workflow || {}
  );
  const navigate = useNavigate();
  const { accountid } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const channel = searchParams.get("channel") === "whatsapp_web" ? "whatsapp_web" : searchParams.get("channel") === "facebook" ? "facebook" : searchParams.get("channel") === "instagram" ? "instagram" : searchParams.get("channel") === "website" ? "website" : searchParams.get("channel") === "qr" ? "qr" : "whatsapp";
  // The "WhatsApp (QR)" tab exists only for accounts staff enabled for QR (or while the URL already points at it).
  const qrPilotEnabled = useSelector((s) => Boolean(s.workspace?.currentWorkspace?.qrPilotEnabled));
  const [workflowTab, setWorkflowTab] = useState(channel);
  // A QR workflow belongs to ONE QR number and runs only for that number's contacts. With two or more numbers the list is
  // shown per number and a new workflow is created for the chosen one; with a single number there is nothing to choose.
  const qrNumbers = useSelector((s) => (
    s.workspace?.currentWorkspace?.qrPilotEnabled && Array.isArray(s.workspace?.currentWorkspace?.whatsappQrConnections)
      ? s.workspace.currentWorkspace.whatsappQrConnections
      : NO_QR_NUMBERS
  ));
  // QR workflows exist only where there is a QR number: the "WhatsApp (QR)" tab and the QR choices in "Add workflow" stay hidden until the
  // workspace has one (removing the last number hides them again). The account switch alone (qrPilotEnabled) is not enough.
  const showQrWorkflows = qrPilotEnabled && qrNumbers.length > 0;
  // WhatsApp Web needs the official WhatsApp (Meta) API connected; the tab stays reachable by URL so an existing workflow is never hidden.
  const whatsappApiConnected = useSelector((s) => Boolean(s.workspace?.currentWorkspace?.whatsappConnected));
  const showWhatsappWebTab = whatsappApiConnected || workflowTab === "whatsapp_web";
  const workspaceFlagsLoaded = useSelector((s) => typeof s.workspace?.currentWorkspace?.qrPilotEnabled === "boolean");
  useEffect(() => {
    // A link/bookmark to ?channel=qr in a workspace without a QR number lands on the normal WhatsApp tab (only once the workspace is loaded).
    if (workspaceFlagsLoaded && workflowTab === "qr" && !showQrWorkflows) setWorkflowTab("whatsapp");
  }, [workspaceFlagsLoaded, workflowTab, showQrWorkflows]);
  const [qrNumberId, setQrNumberId] = useState("");
  useEffect(() => {
    if (workflowTab !== "qr" || qrNumbers.length < 1) return;
    if (qrNumbers.some((n) => n.connectionId === qrNumberId)) return;
    setQrNumberId(qrNumbers[0].connectionId); // always one number selected: the first until another is chosen
  }, [workflowTab, qrNumbers, qrNumberId]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState({});
  const [sortField, setSortField] = useState({});
  const [sortDirection, setSortDirection] = useState({});
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [addDialogView, setAddDialogView] = useState('initial');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteTrigger, setDeleteTrigger] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]);
  const [selectedTemplateForPreview, setSelectedTemplateForPreview] = useState(null);
  const [previewChannel, setPreviewChannel] = useState('whatsapp');

  useEffect(() => {
    const want = workflowTab === "whatsapp_web" ? "whatsapp_web" : workflowTab === "facebook" ? "facebook" : workflowTab === "instagram" ? "instagram" : workflowTab === "website" ? "website" : workflowTab === "shopify" ? "shopify" : workflowTab === "qr" ? "qr" : "whatsapp";
    const current = searchParams.get("channel");
    if ((want === "facebook" && current !== "facebook") || (want === "instagram" && current !== "instagram") || (want === "website" && current !== "website") || (want === "qr" && current !== "qr") || (want === "whatsapp_web" && current !== "whatsapp_web") || (want === "whatsapp" && current != null)) {
      setSearchParams(want === "whatsapp" ? {} : { channel: want });
    }
  }, [workflowTab, searchParams, setSearchParams]);

  useEffect(() => { setWorkflowTab(channel); }, [channel]);
  useEffect(() => { dispatch(fetchUserPermissions()); }, [dispatch]);
  useEffect(() => { dispatch(fetchWorkflows(workflowTab)); }, [dispatch, workflowTab]);

  if (WorkflowPermissions.View === false) return <AuthView />;

  // Nothing at all for this channel tab (not just "no search matches"): every trigger group is
  // empty, or there are no groups.
  // QR tab: the number chips are always shown (even for one number) and ONLY the selected number's workflows are listed. A
  // removed number's workflows stay in the database, hidden; they are not shown under any other number, and come back under the
  // number if the same phone is added again. Every other tab is shown exactly as before.
  const qrByNumber = workflowTab === "qr" && qrNumbers.length >= 1;
  const isKnownQrNumber = (cid) => qrNumbers.some((n) => n.connectionId === cid);
  const formatQrPhone = (p) => (p ? (/^\d+$/.test(String(p)) ? `+${p}` : String(p)) : "");
  const qrNumberLabel = (n) => [n.label, formatQrPhone(n.phoneNumber)].filter(Boolean).join(" · ") || `Number ${(n.slot || 0) + 1}`;
  const allGroups = Array.isArray(workflowGroups) ? workflowGroups : [];
  const visibleGroups = workflowTab === "qr"
    ? allGroups.map((g) => ({ ...g, workflows: (g.workflows || []).filter((w) => w.connectionId === qrNumberId) })).filter((g) => g.workflows.length > 0)
    : allGroups;
  // The number a new QR workflow is created for: the selected chip. null = a number exists but none is selected yet.
  const qrCreateFields = (ch) => {
    if (ch !== "qr" || qrNumbers.length === 0) return {}; // no number at all: the server explains that one must be connected first
    return isKnownQrNumber(qrNumberId) ? { connectionId: qrNumberId } : null;
  };
  const noWorkflowsForChannel = !visibleGroups.some(g => (g.workflows || []).length > 0);

  const mapWorkflow = (wf) => ({
    id: wf._id,
    name: wf.name,
    execution: wf.execution || "-",
    status: wf.status === "on" ? "On" : "Off",
    description: wf.description,
    totalEnrolled: wf.enrollment || 0,
    sevenDayEnrolled: wf.last7DayEnrollment || 0,
    createdAt: wf.createdAt,
    triggerName: wf.triggerName || "Other",
    mediaExpiry: wf.mediaExpiry || null,
  });

  const getFilteredSorted = (trigger, workflows) => {
    let data = workflows.map(mapWorkflow);
    if (search.trim()) {
      const s = search.toLowerCase();
      data = data.filter(w =>
        w.name.toLowerCase().includes(s) ||
        w.status.toLowerCase().includes(s) ||
        w.description.toLowerCase().includes(s)
      );
    }
    const field = sortField[trigger] || "createdAt";
    const direction = sortDirection[trigger] || "desc";
    data = [...data].sort((a, b) => {
      let aVal = a[field]; let bVal = b[field];
      if (field === "createdAt") { aVal = new Date(aVal); bVal = new Date(bVal); }
      if (aVal < bVal) return direction === "asc" ? -1 : 1;
      if (aVal > bVal) return direction === "asc" ? 1 : -1;
      return 0;
    });
    return data;
  };

  const isAllChecked = (trigger, filtered) =>
    filtered.length > 0 && filtered.every(w => (selected[trigger] || []).includes(w.id));

  const handleSelectAll = (trigger, filtered) => e => {
    setSelected(prev => {
      const prevSel = prev[trigger] || [];
      if (e.target.checked) {
        return { ...prev, [trigger]: [...prevSel, ...filtered.map(w => w.id).filter(id => !prevSel.includes(id))] };
      }
      return { ...prev, [trigger]: prevSel.filter(id => !filtered.map(w => w.id).includes(id)) };
    });
  };

  const handleSelect = (trigger, id) => {
    setSelected(prev => {
      const prevSel = prev[trigger] || [];
      return { ...prev, [trigger]: prevSel.includes(id) ? prevSel.filter(i => i !== id) : [...prevSel, id] };
    });
  };

  const handleSort = (trigger, field) => {
    setSortField(prev => {
      if ((prev[trigger] || "createdAt") === field) {
        setSortDirection(d => ({ ...d, [trigger]: (d[trigger] || "desc") === "asc" ? "desc" : "asc" }));
        return prev;
      }
      setSortDirection(d => ({ ...d, [trigger]: "asc" }));
      return { ...prev, [trigger]: field };
    });
  };

  const closeAddDialog = () => {
    setAddDialogOpen(false);
    setAddDialogView('initial');
    setSelectedTemplateForPreview(null);
  };

  const handleAddWorkflowFromScratch = async () => {
    const qrFields = qrCreateFields(workflowTab === "qr" ? "qr" : "other");
    if (qrFields === null) { toast.error("Choose a WhatsApp number first -- a QR workflow runs only for that number.", { id: "workflow-qr-number", duration: 5000 }); return; }
    const { blocked, message } = await checkSubscriptionActive(getAuthToken);
    if (blocked) { toast.error(message, { id: 'subscription-blocked', duration: 5000 }); closeAddDialog(); return; }
    closeAddDialog();
    const workflowData = {
      description: '',
      steps: [],
      channel: workflowTab === "whatsapp_web" ? "whatsapp_web" : workflowTab === "facebook" ? "facebook" : workflowTab === "instagram" ? "instagram" : workflowTab === "website" ? "website" : workflowTab === "shopify" ? "shopify" : workflowTab === "qr" ? "qr" : "whatsapp",
      ...qrFields,
    };
    try {
      const resultAction = await dispatch(createWorkflow(workflowData));
      if (createWorkflow.fulfilled.match(resultAction)) {
        const newWorkflow = resultAction.payload;
        const wfId = newWorkflow.id || newWorkflow._id;
        dispatch(setSelectedWorkflow({ ...newWorkflow, channel: workflowData.channel }));
        if (wfId) dispatch(fetchWorkflowById(wfId));
        navigate(`/home/${accountid}/workflow/${wfId}/create${workflowCreateChannelSuffix(workflowTab)}`);
      } else if (createWorkflow.rejected.match(resultAction)) {
        const payload = resultAction.payload;
        const errMsg = typeof payload === 'string' ? payload : (payload?.message || 'Failed to create workflow.');
        if (!isSubscriptionBlockedError(errMsg)) toast.error(errMsg, { id: 'workflow-create-error', duration: 5000 });
      }
    } catch (error) {
      if (!isSubscriptionBlockedError(error?.message || error)) toast.error('Failed to create workflow.');
    }
  };

  const handleAddWorkflowClick = async () => {
    try {
      const token = await getAuthToken();
      if (token) {
        const res = await fetch(`${SERVER_DOMAIN}/api/subscriptions/me`, { headers: { Authorization: `Bearer ${token}` } });
        if (res.ok) {
          const data = await res.json();
          const sub = data?.subscription;
          if (sub) {
            const now = new Date();
            const trialEnded = sub.status === 'trial' && sub.trialEnd && new Date(sub.trialEnd) < now;
            if (sub.status === 'expired' || sub.status === 'cancelled') {
              toast.error('Your subscription is not active. Please contact ClusterDen to restore access.', { id: 'subscription-blocked', duration: 5000 }); return;
            }
            if (sub.status === 'payment_failed') {
              toast.error('Your subscription payment failed. Outbound actions are disabled until billing is resolved.', { id: 'subscription-blocked', duration: 5000 }); return;
            }
            if (trialEnded) {
              toast.error('Your trial has ended. Please upgrade your plan to continue using ClusterDen.', { id: 'subscription-blocked', duration: 5000 }); return;
            }
          }
          const wfFeature = (data?.features || []).find(f => f.key === 'workflowCreations');
          if (wfFeature && wfFeature.limit > 0 && wfFeature.used >= wfFeature.limit) {
            toast.error('Your workflow creation limit is reached. Please upgrade your plan to create more workflows.', { id: 'workflow-limit', duration: 5000 }); return;
          }
        }
      }
    } catch { /* server will enforce */ }
    setAddDialogOpen(true);
  };

  const handleTemplateCardClick = (template) => {
    if (workflowTab === "qr" && !QR_TEMPLATE_IDS.has(template.id)) return; // listed but disabled in the QR tab
    if (workflowTab === "whatsapp_web") return; // the recipes are for other channels; a WhatsApp Web workflow starts blank
    if (template.multiChannel) {
      setSelectedTemplateForPreview(template);
      // Default to current tab if that channel is available; otherwise first channel in config. The QR option exists only for
      // QR-enabled accounts.
      const available = Object.keys(template.channelConfig).filter((k) => k !== "qr" || showQrWorkflows);
      setPreviewChannel(available.includes(workflowTab) ? workflowTab : available[0]);
      // With several QR numbers a QR workflow needs one chosen: start from the chip already selected (or the first number).
      if (qrNumbers.length >= 1 && !isKnownQrNumber(qrNumberId)) setQrNumberId(qrNumbers[0].connectionId);
      setAddDialogView('templatePreview');
    } else {
      handleAddWorkflowFromTemplate(template);
    }
  };

  const handleAddWorkflowFromTemplate = async (template, channelOverride) => {
    const templateChannelIsQr = (channelOverride || template.forceChannel || workflowTab) === "qr";
    const qrFields = qrCreateFields(templateChannelIsQr ? "qr" : "other");
    if (qrFields === null) { toast.error("Choose which WhatsApp number this workflow is for -- a QR workflow runs only for that number.", { id: "workflow-qr-number", duration: 5000 }); return; }
    closeAddDialog();

    const effectiveChannel = channelOverride || template.forceChannel || (workflowTab === "whatsapp_web" ? "whatsapp_web" : workflowTab === "facebook" ? "facebook" : workflowTab === "instagram" ? "instagram" : workflowTab === "website" ? "website" : workflowTab === "shopify" ? "shopify" : workflowTab === "qr" ? "qr" : "whatsapp");

    let resolvedTriggerName = template.triggerName;
    let resolvedWorkflowName = template.workflowName;
    if (template.multiChannel && template.channelConfig?.[effectiveChannel]) {
      resolvedTriggerName = template.channelConfig[effectiveChannel].triggerName;
      resolvedWorkflowName = template.channelConfig[effectiveChannel].workflowName;
    }

    const workflowData = { name: resolvedWorkflowName, description: '', steps: [], channel: effectiveChannel, ...(effectiveChannel === "qr" ? qrFields : {}) };

    let resultAction;
    try { resultAction = await dispatch(createWorkflow(workflowData)); } catch { return; }
    if (!createWorkflow.fulfilled.match(resultAction)) return;

    const newWorkflow = resultAction.payload;
    const wfId = newWorkflow.id || newWorkflow._id;
    const baseWorkflow = {
      ...newWorkflow,
      name: resolvedWorkflowName,
      channel: effectiveChannel,
      currentVersion: { ...(newWorkflow.currentVersion || { branches: { start: [] } }), name: resolvedWorkflowName },
    };
    dispatch(setSelectedWorkflow(baseWorkflow));

    let triggersData = reduxTriggers;
    if (!Array.isArray(triggersData) || triggersData.length === 0) {
      const fetchResult = await dispatch(fetchTriggers());
      triggersData = fetchResult.payload || [];
    }

    const flatTriggers = (Array.isArray(triggersData) ? triggersData : []).flatMap(cat => cat.triggers || []);
    // Fall back to locally-defined trigger configs for Instagram/Facebook (not stored in DB)
    const baseTrigger = flatTriggers.find(t => t.name === resolvedTriggerName) || LOCAL_CHANNEL_TRIGGERS[resolvedTriggerName] || null;
    const isLocalTrigger = !flatTriggers.find(t => t.name === resolvedTriggerName) && !!LOCAL_CHANNEL_TRIGGERS[resolvedTriggerName];

    if (baseTrigger && wfId) {
      let triggerWithConfig;
      if (resolvedTriggerName === 'Office-Time Flow') {
        const officeConfig = {
          timezone: 'Asia/Karachi',
          officeHours: {
            Monday: [{ start: '09:00', end: '18:00', workflowId: '', workflowName: '' }],
            Tuesday: [{ start: '09:00', end: '18:00', workflowId: '', workflowName: '' }],
            Wednesday: [{ start: '09:00', end: '18:00', workflowId: '', workflowName: '' }],
            Thursday: [{ start: '09:00', end: '18:00', workflowId: '', workflowName: '' }],
            Friday: [{ start: '09:00', end: '18:00', workflowId: '', workflowName: '' }],
          },
          nonOfficeWorkflow: { workflowId: '', workflowName: '' },
        };
        triggerWithConfig = { ...baseTrigger, config: [officeConfig] };
      } else if (isLocalTrigger) {
        // Local triggers (Instagram, Facebook) already have selectedValue set — use as-is
        triggerWithConfig = { ...baseTrigger };
      } else {
        const config = (baseTrigger.config || []).map(cfg => ({
          ...cfg,
          fields: (cfg.fields || []).map(field => {
            let selectedValue;
            if (field.options && Array.isArray(field.options) && field.options[0] === 'timezones') selectedValue = 'Asia/Karachi';
            else if (field.type === 'number') selectedValue = 1;
            else if (field.type === 'select' && Array.isArray(field.options) && field.options.length > 0) selectedValue = field.options[0];
            else selectedValue = '';
            return { ...field, selectedValue };
          }),
        }));
        triggerWithConfig = { ...baseTrigger, config };
      }

      const triggerNode = { id: Date.now().toString(), type: 'trigger', trigger: triggerWithConfig };
      dispatch(addNodeToBranch({ branchId: 'start', node: triggerNode, nodeIndex: 0 }));

      const workflowToSave = {
        ...baseWorkflow,
        currentVersion: { ...(baseWorkflow.currentVersion || {}), branches: { start: [triggerNode] } },
      };

      try {
        const token = await getAuthToken();
        if (token) {
          await axios.put(
            `${SERVER_DOMAIN}/api/workflow/update/${wfId}`,
            workflowToSave,
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
          );
        }
      } catch { /* continue to navigation */ }
    }

    if (wfId) {
      dispatch(fetchWorkflowById(wfId));
      navigate(`/home/${accountid}/workflow/${wfId}/create${workflowCreateChannelSuffix(effectiveChannel)}`);
    }
  };

  return (
    <Box sx={{
      height: "100%", width: "100%",
      pt: { xs: 1, sm: 1.5, md: 1.5, lg: 2, xl: 2 },
      px: { xs: 1, sm: 1.5, md: 1.5, lg: 2, xl: 2 },
      pb: { xs: 0, sm: 0, md: 1.5, lg: 2, xl: 2 },
      boxSizing: "border-box", bgcolor: theme.palette.background.default,
      display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden',
    }}>
      <Tabs
        value={workflowTab}
        onChange={(_, v) => setWorkflowTab(v)}
        sx={{
          mb: { xs: 1, sm: 1.25 }, minHeight: 40,
          "& .MuiTab-root": { minHeight: 40, textTransform: "none", fontWeight: 600, fontSize: { xs: "0.8rem", sm: "0.9rem" } },
        }}
      >
        <Tab label="WhatsApp" value="whatsapp" />
        {showQrWorkflows && <Tab label="WhatsApp (QR)" value="qr" />}
        {showWhatsappWebTab && <Tab label="WhatsApp Webchat" value="whatsapp_web" />}
        <Tab label="Instagram" value="instagram" />
        <Tab label="Facebook" value="facebook" />
        <Tab label="Website Chat" value="website" />
        <Tab label="Shopify" value="shopify" />
      </Tabs>

      {qrByNumber && (
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.25, mb: { xs: 1.25, sm: 1.5 } }}>
          <Typography sx={{ color: "text.secondary", fontWeight: 600, fontSize: { xs: "0.9rem", sm: "1rem" }, mr: 0.5 }}>Number:</Typography>
          {qrNumbers.map((n) => (
            <Chip
              key={n.connectionId}
              label={qrNumberLabel(n)}
              color={qrNumberId === n.connectionId ? "primary" : "default"}
              variant={qrNumberId === n.connectionId ? "filled" : "outlined"}
              onClick={() => setQrNumberId(n.connectionId)}
              sx={{ height: { xs: 32, sm: 38 }, borderRadius: "19px", fontSize: { xs: "0.875rem", sm: "1rem" }, fontWeight: 600, px: 0.75 }}
            />
          ))}
        </Box>
      )}

      <Box sx={{
        display: "flex", flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        mb: { xs: 1, sm: 1.25, md: 1.5, lg: 2, xl: 2 },
        gap: { xs: 0.75, sm: 1, md: 1.5, lg: 2, xl: 2 },
      }}>
        <TextField
          variant="outlined" placeholder="Search workflows..." value={search}
          onChange={e => setSearch(e.target.value)}
          size={isXs || isSm ? 'small' : 'medium'}
          InputProps={{ startAdornment: <SearchIcon sx={{ mr: { xs: 0.5, sm: 0.5, md: 0.75, lg: 1 }, fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1.1rem', lg: '1.25rem' } }} /> }}
          sx={{
            flex: 1, minWidth: { xs: '100%', sm: 200 },
            '& .MuiInputBase-root': { fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.95rem', lg: '1rem' } },
          }}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1.1rem', lg: '1.25rem' } }} />}
          onClick={handleAddWorkflowClick}
          size={isXs || isSm ? 'small' : 'medium'}
          sx={{
            borderRadius: { xs: 1.5, sm: 2, md: 2.5, lg: 3 }, textTransform: "none", fontWeight: "bold", whiteSpace: 'nowrap',
            fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.85rem', lg: '0.9rem' },
            px: { xs: 1, sm: 1.5, md: 2, lg: 2.5 }, py: { xs: 0.5, sm: 0.625, md: 0.875, lg: 1 },
          }}
        >
          Add Workflow
        </Button>
      </Box>

      {/* Add Workflow Dialog */}
      <Dialog
        open={addDialogOpen}
        onClose={closeAddDialog}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            width: addDialogView === 'initial'
              ? 'min(380px, calc(100vw - 48px))'
              : 'min(1100px, calc(100vw - 48px))',
            maxHeight: '90vh',
            bgcolor: '#FFFFFF',
            borderRadius: '16px',
            boxShadow: '0 24px 80px rgba(15, 23, 42, 0.12)',
            pt: 1.25,
            px: 2,
            pb: 2,
            mx: 'auto',
            overflow: 'hidden',
          },
        }}
      >
        <DialogTitle sx={{
          fontSize: { xs: '0.9rem', sm: '1rem', md: '1.0rem', lg: '1.2rem' },
          display: 'flex', alignItems: 'center', justifyContent: 'start',
          position: 'relative',
          py: 1.25,
          px: 4,
        }}>
          {/* {addDialogView === 'templates' && (
            <IconButton size="small" onClick={() => setAddDialogView('initial')} sx={{ mr: 0.5 }}>
              <ArrowBackIosNewIcon sx={{ fontSize: '1rem' }} />
            </IconButton>
          )} */}
          {addDialogView === 'templatePreview'
            ? 'Preview'
            : addDialogView === 'templates'
            ? 'Create workflow from template'
            : 'Add Workflow'}
        </DialogTitle>

        <DialogContent sx={{ px: { xs: 2, sm: 2.5, md: 3 }, pt: { xs: 0.5, sm: 0.75 }, overflowY: 'auto', maxHeight: 'calc(90vh - 120px)' }}>
          {/* Initial: From Scratch / From Template */}
          {addDialogView === 'initial' && (
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, py: 0.2 , marginTop:'20px' }}>
              <Button variant="contained" color="primary" onClick={handleAddWorkflowFromScratch}
                sx={{ px: 3, py: 1, fontSize: '0.95rem' }}>
                From Scratch
              </Button>
              <Button variant="outlined" color="primary" onClick={() => setAddDialogView('templates')}
                sx={{ px: 3, py: 1, fontSize: '0.95rem' }}>
                From Template
              </Button>
            </Box>
          )}

          {/* Template list */}
          {addDialogView === 'templates' && (
            <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                placeholder="Search templates"
                variant="outlined"
                fullWidth
                defaultValue=""
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#6B7280' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    minHeight: 40,
                    borderRadius: '22px',
                    bgcolor: '#FFFFFF',
                  },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E5E7EB' },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9CA3AF' },
                }}
              />
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', md: 'repeat(3, minmax(0, 1fr))' },
                gap: '20px',
                mt: 1,
              }}>
                {WORKFLOW_TEMPLATES.map(template => {
                  const showPopular = template.id === 'first-message' || template.id === 'comment-on-post';
                  const iconMeta = {
                    'first-message': { icon: <ChatBubbleIcon sx={{ fontSize: '1.3rem' }} />, color: '#15803D', bg: '#DCFCE7' },
                    'comment-on-story': { icon: <MessageIcon sx={{ fontSize: '1.3rem' }} />, color: '#15803D', bg: '#DCFCE7' },
                    'comment-on-post': { icon: <ChatBubbleOutlineIcon sx={{ fontSize: '1.3rem' }} />, color: '#15803D', bg: '#DCFCE7' },
                    'automatic-reply-to-comment': { icon: <AutoAwesomeIcon sx={{ fontSize: '1.3rem' }} />, color: '#0EA5E9', bg: '#DBEAFE' },
                    'place-order': { icon: <ShoppingBagIcon sx={{ fontSize: '1.3rem' }} />, color: '#15803D', bg: '#DCFCE7' },
                    'office-time': { icon: <AccessTimeIcon sx={{ fontSize: '1.3rem' }} />, color: '#4B5563', bg: '#E5E7EB' },
                  }[template.id] || { icon: <PersonIcon sx={{ fontSize: '1.3rem' }} />, color: '#111827', bg: '#F3F4F6' };
                  const supportedChannels = {
                    'first-message': ['whatsapp', 'qr', 'instagram', 'facebook', 'website'],
                    'comment-on-story': ['instagram'],
                    'comment-on-post': ['instagram', 'facebook'],
                    'automatic-reply-to-comment': ['instagram', 'facebook'],
                    'place-order': ['whatsapp'],
                    'office-time': ['whatsapp', 'qr'],
                  }[template.id] || [];
                  // QR tab only: a template that cannot run on a QR number stays visible but disabled, with the reason.
                  const qrDisabled = (workflowTab === "qr" && !QR_TEMPLATE_IDS.has(template.id)) || workflowTab === "whatsapp_web";

                  return (
                    <Paper
                      key={template.id}
                      variant="outlined"
                      onClick={() => handleTemplateCardClick(template)}
                      aria-disabled={qrDisabled || undefined}
                      sx={{
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E5E7EB',
                        borderRadius: '14px',
                        p: 1.5,
                        minHeight: 200,
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: qrDisabled ? 'not-allowed' : 'pointer',
                        ...(qrDisabled ? { opacity: 0.5 } : {}),
                        transition: 'transform 180ms ease, box-shadow 180ms ease',
                        '&:hover': qrDisabled ? {} : {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
                        },
                      }}
                    >
                      <Box sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: iconMeta.bg,
                        color: iconMeta.color,
                        mb: 2,
                      }}>
                        {iconMeta.icon}
                      </Box>
                      <Typography sx={{
                        fontSize: '1.25rem',
                        fontWeight: 600,
                        color: '#111827',
                        lineHeight: 1.2,
                        mb: 1,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}>
                        {template.label}
                      </Typography>
                      <Typography sx={{
                        fontSize: '0.9375rem',
                        color: '#6B7280',
                        lineHeight: 1.5,
                        mb: 2,
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}>
                        {template.description}
                      </Typography>
                      {qrDisabled && (
                        <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600, color: '#B45309' }}>
                          {workflowTab === "whatsapp_web"
                            ? 'Not available for WhatsApp Webchat -- start with a blank workflow'
                            : `Not available for WhatsApp (QR) -- ${QR_TEMPLATE_UNAVAILABLE_REASON[template.id] || 'not supported'}`}
                        </Typography>
                      )}
                      <Box sx={{ flexGrow: 1 }} />
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mt: 2 }}>
                        {showPopular ? (
                          <Box sx={{
                            borderRadius: '999px',
                            px: 1.5,
                            py: 0.5,
                            bgcolor: '#EEF2FF',
                            color: '#4338CA',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                          }}>
                            Popular
                          </Box>
                        ) : <Box sx={{ minWidth: 54 }} />}
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          {supportedChannels.includes('whatsapp') && <WhatsAppIcon sx={{ color: '#25D366', fontSize: '2rem' }} />}
                          {supportedChannels.includes('qr') && showQrWorkflows && (
                            <Box sx={{ borderRadius: '999px', px: 1, py: 0.25, bgcolor: '#DCFCE7', color: '#15803D', fontSize: '0.75rem', fontWeight: 700 }}>QR</Box>
                          )}
                          {supportedChannels.includes('instagram') && <InstagramIcon sx={{ color: '#E1306C', fontSize: '2rem' }} />}
                          {supportedChannels.includes('facebook') && <FacebookIcon sx={{ color: '#1877F2', fontSize: '2rem' }} />}
                          {supportedChannels.includes('website') && <LanguageIcon sx={{ color: '#1e7d4d', fontSize: '2rem' }} />}
                        </Box>
                      </Box>
                    </Paper>
                  );
                })}
              </Box>
            </Box>
          )}

          {/* Template preview: two-panel */}
          {addDialogView === 'templatePreview' && selectedTemplateForPreview && (
            <Box sx={{
              display: 'flex', flexDirection: { xs: 'column', md: 'row' },
              gap: { xs: 2.5, md: 3 }, mt: 0.5,
            }}>
              {/* Left: channel pill + info */}
              <Box sx={{ flex: '0 0 42%', display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* Select channel pill */}
                <FormControl size="small" sx={{ alignSelf: 'flex-start' }}>
                  <Select
                    value={previewChannel}
                    onChange={e => setPreviewChannel(e.target.value)}
                    sx={{
                      borderRadius: '20px',
                      minWidth: 148,
                      '& .MuiSelect-select': { py: 0.875, pl: 1.75, pr: '32px !important', fontSize: '0.85rem' },
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
                      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' },
                    }}
                    renderValue={(val) => (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        {(val === 'whatsapp' || val === 'qr') && <WhatsAppIcon sx={{ color: '#25D366', fontSize: '1rem' }} />}
                        {val === 'instagram' && <InstagramIcon sx={{ color: '#E1306C', fontSize: '1rem' }} />}
                        {val === 'facebook' && <FacebookIcon sx={{ color: '#1877F2', fontSize: '1rem' }} />}
                        {val === 'website' && <LanguageIcon sx={{ color: '#1e7d4d', fontSize: '1rem' }} />}
                        <Typography fontSize="0.85rem">
                          {val === 'whatsapp' ? 'WhatsApp' : val === 'qr' ? 'WhatsApp (QR)' : val === 'instagram' ? 'Instagram' : val === 'website' ? 'Website' : 'Facebook'}
                        </Typography>
                      </Box>
                    )}
                  >
                    {selectedTemplateForPreview.channelConfig.whatsapp && (
                      <MenuItem value="whatsapp">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <WhatsAppIcon sx={{ color: '#25D366', fontSize: '1rem' }} />
                          <Typography fontSize="0.875rem">WhatsApp</Typography>
                        </Box>
                      </MenuItem>
                    )}
                    {selectedTemplateForPreview.channelConfig.qr && showQrWorkflows && (
                      <MenuItem value="qr">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <WhatsAppIcon sx={{ color: '#25D366', fontSize: '1rem' }} />
                          <Typography fontSize="0.875rem">WhatsApp (QR)</Typography>
                        </Box>
                      </MenuItem>
                    )}
                    {selectedTemplateForPreview.channelConfig.instagram && (
                      <MenuItem value="instagram">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <InstagramIcon sx={{ color: '#E1306C', fontSize: '1rem' }} />
                          <Typography fontSize="0.875rem">Instagram</Typography>
                        </Box>
                      </MenuItem>
                    )}
                    {selectedTemplateForPreview.channelConfig.facebook && (
                      <MenuItem value="facebook">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <FacebookIcon sx={{ color: '#1877F2', fontSize: '1rem' }} />
                          <Typography fontSize="0.875rem">Facebook</Typography>
                        </Box>
                      </MenuItem>
                    )}
                    {selectedTemplateForPreview.channelConfig.website && (
                      <MenuItem value="website">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <LanguageIcon sx={{ color: '#1e7d4d', fontSize: '1rem' }} />
                          <Typography fontSize="0.875rem">Website</Typography>
                        </Box>
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>

                {previewChannel === 'qr' && qrNumbers.length > 1 && (
                  <FormControl size="small" sx={{ alignSelf: 'flex-start' }}>
                    <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600, color: 'text.secondary', mb: 0.5 }}>
                      Which WhatsApp number is this workflow for?
                    </Typography>
                    <Select
                      value={isKnownQrNumber(qrNumberId) ? qrNumberId : ''}
                      onChange={(e) => setQrNumberId(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: '20px', minWidth: 220, '& .MuiSelect-select': { py: 0.875, pl: 1.75, fontSize: '0.9rem', fontWeight: 600 } }}
                    >
                      {qrNumbers.map((n) => (
                        <MenuItem key={n.connectionId} value={n.connectionId}>
                          {qrNumberLabel(n)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                <Typography fontWeight={700} fontSize={{ xs: '1.2rem', sm: '1.3rem', md: '1.4rem' }} lineHeight={1.35}>
                  {selectedTemplateForPreview.previewTitle || selectedTemplateForPreview.label}
                </Typography>

                {(selectedTemplateForPreview.previewDescriptions || [selectedTemplateForPreview.description]).map((desc, i) => (
                  <Typography key={i} color="text.secondary" fontSize={{ xs: '0.95rem', md: '1rem' }} lineHeight={1.65}>
                    {desc}
                  </Typography>
                ))}
              </Box>

              {/* Right: preview image */}
              <Box sx={{
                flex: 1,
                borderRadius: 2,
                overflow: 'hidden',
                minHeight: { xs: 280, md: 320 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Box
                  component="img"
                  src={workflowPreviewImg}
                  alt="Workflow preview"
                  sx={{ width: '80%', height: 'auto', objectFit: 'contain', display: 'block', borderRadius: 2 }}
                />
              </Box>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: { xs: 1.5, sm: 2, md: 2 }, pb: { xs: 1, sm: 1.5, md: 2 }, gap: 0.5 }}>
          {addDialogView === 'templatePreview' ? (
            <>
              <Button onClick={() => setAddDialogView('templates')} size={isXs || isSm ? 'small' : 'medium'}
                sx={{ fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' } }}>
                Back
              </Button>
              <Button
                variant="contained"
                onClick={() => handleAddWorkflowFromTemplate(selectedTemplateForPreview, previewChannel)}
                size={isXs || isSm ? 'small' : 'medium'}
                sx={{ fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' } }}
              >
                Create
              </Button>
            </>
          ) : (
            <Button onClick={closeAddDialog} size={isXs || isSm ? 'small' : 'medium'}
              sx={{ fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' } }}>
              Cancel
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Scrollable workflow tables */}
      <Box sx={{
        flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden',
        pb: { xs: 0, sm: 0, md: 6, lg: 6, xl: 6 },
        mb: { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 },
        scrollbarWidth: { xs: "none", sm: "none", md: "auto" },
        msOverflowStyle: { xs: "none", sm: "none", md: "auto" },
        '&::-webkit-scrollbar': { width: { xs: 0, sm: 0, md: '8px', lg: '10px' } },
        '&::-webkit-scrollbar-track': { background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' },
        '&::-webkit-scrollbar-thumb': { background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)', borderRadius: '10px' },
      }}>
        {loading ? (
          <Box sx={{ textAlign: 'center', mt: { xs: 2, sm: 3, md: 4 }, color: 'text.primary' }}>
            <Typography sx={{ fontWeight: 500, fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem', lg: '1rem' } }}>
              Loading workflows...
            </Typography>
          </Box>
        ) : error ? (
          <Box sx={{ textAlign: 'center', mt: { xs: 2, sm: 3, md: 4 }, color: 'red', fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem', lg: '1rem' } }}>
            {error.toString()}
          </Box>
        ) : noWorkflowsForChannel ? (
          // Same layout as Inbox's "No conversation selected" empty state; icon is the app's own
          // Workflow icon (LeftNav's "Workflow" item). No button -- "Add Workflow" is already in
          // the toolbar above.
          <Box sx={{ height: '100%', minHeight: 240, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', px: 4 }}>
            <Box sx={{ mb: 1.5, color: 'text.secondary', display: 'flex' }}>
              <Hierarchy size={64} color="currentColor" variant="Linear" />
            </Box>
            <Typography sx={{ fontWeight: 600, fontSize: '1.05rem', color: 'text.primary', mb: 0.5 }}>
              No workflows yet
            </Typography>
            <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', maxWidth: 340 }}>
              {workflowTab === "qr" && qrNumbers.length === 0
                ? "Connect a WhatsApp QR number first -- QR workflows belong to a number."
                : workflowTab === "qr"
                  ? "This number has no workflows yet. Use the Add Workflow button to create the first one for it."
                  : "Use the Add Workflow button to create your first workflow for this channel."}
            </Typography>
          </Box>
        ) : (
          visibleGroups.map(group => {
            const trigger = group.trigger;
            const workflows = group.workflows || [];
            const filtered = getFilteredSorted(trigger, workflows);
            const icon = getWorkflowListTriggerIcon(trigger, workflowTab);
            return (
              <Box key={trigger}>
                <WorkflowSectionHeader trigger={trigger} count={filtered.length} icon={icon} />
                <WorkflowTable
                  workflows={filtered}
                  selected={selected[trigger] || []}
                  onSelect={id => handleSelect(trigger, id)}
                  onSelectAll={handleSelectAll(trigger, filtered)}
                  isAllChecked={isAllChecked(trigger, filtered)}
                  sortField={sortField[trigger] || "createdAt"}
                  sortDirection={sortDirection[trigger] || "desc"}
                  onSort={field => handleSort(trigger, field)}
                  getRelativeTime={getRelativeTime}
                  onWorkflowClick={wf => {
                    dispatch(fetchWorkflowById(wf.id || wf._id));
                    dispatch(setSelectedWorkflow(wf));
                    navigate(`/home/${accountid}/workflow/${wf.id || wf._id}/create${workflowCreateChannelSuffix(workflowTab)}`);
                  }}
                  onDeleteSelected={() => {
                    const ids = selected[trigger] || [];
                    if (ids.length === 0) return;
                    setDeleteTrigger(trigger);
                    setDeleteIds(ids);
                    setConfirmDeleteOpen(true);
                  }}
                />
              </Box>
            );
          })
        )}
      </Box>

      {/* Delete confirmation dialog */}
      <Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)} fullWidth={isXs || isSm} maxWidth={isXs || isSm ? 'sm' : 'md'}>
        <DialogTitle sx={{ fontSize: { xs: '0.9rem', sm: '0.95rem', md: '1rem', lg: '1.25rem' } }}>
          Delete Workflows?
        </DialogTitle>
        <DialogContent sx={{ fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem', lg: '1rem' } }}>
          Are you sure you want to delete {deleteIds.length} workflow{deleteIds.length > 1 ? 's' : ''}? This action cannot be undone.
        </DialogContent>
        <DialogActions sx={{ px: { xs: 1.5, sm: 2, md: 2 }, pb: { xs: 1, sm: 1.5, md: 2 } }}>
          <Button onClick={() => setConfirmDeleteOpen(false)} size={isXs || isSm ? 'small' : 'medium'}
            sx={{ fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem', lg: '0.9rem' } }}>
            Cancel
          </Button>
          <Button
            color="error" variant="contained" size={isXs || isSm ? 'small' : 'medium'}
            sx={{ fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem', lg: '0.9rem' } }}
            onClick={async () => {
              const { blocked, message: subMsg } = await checkSubscriptionActive(getAuthToken);
              if (blocked) { toast.error(subMsg, { id: 'subscription-blocked', duration: 5000 }); setConfirmDeleteOpen(false); return; }
              try {
                const token = await getAuthToken();
                if (!token) { toast.error('Authentication required. Please log in again.'); setConfirmDeleteOpen(false); return; }
                await axios.post(`${SERVER_DOMAIN}/api/workflow/deleteMany`, { ids: deleteIds }, {
                  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                });
                dispatch(fetchWorkflows(workflowTab));
                setSelected(prev => ({ ...prev, [deleteTrigger]: [] }));
                toast.success('Workflows deleted successfully.');
              } catch (err) {
                const errMsg = err?.response?.data?.message || err?.message || 'Failed to delete workflows';
                if (!isSubscriptionBlockedError(errMsg)) toast.error(errMsg);
              }
              setConfirmDeleteOpen(false);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Workflow;
